import { render, staticRenderFns } from "./UsageBillTotal.vue?vue&type=template&id=5dd9dc03&scoped=true&"
import script from "./UsageBillTotal.vue?vue&type=script&lang=js&"
export * from "./UsageBillTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd9dc03",
  null
  
)

export default component.exports